import {
  AcademicDegree,
  Author,
  ContactData,
  Education,
  LaborActivity,
  Organization,
  ScientificInterest,
} from 'types/uploadType';
import {
  DELETE_EDUCATION,
  DELETE_EDUCATION_FAILED,
  DELETE_EDUCATION_SUCCESS,
  DELETE_LABOR_ACIVITY,
  DELETE_LABOR_ACIVITY_FAILED,
  DELETE_LABOR_ACIVITY_SUCCESS,
  EDIT_DEGREES,
  EDIT_DEGREES_FAILED,
  EDIT_DEGREES_SUCCESS,
  FIND_CITIES,
  FIND_CITIES_FAILED,
  FIND_CITIES_SUCCESS,
  GET_ACTIVITY_AREAS,
  GET_ACTIVITY_AREAS_FAILED,
  GET_ACTIVITY_AREAS_SUCCESS,
  GET_CONTACTS,
  GET_CONTACTS_FAILED,
  GET_CONTACTS_SUCCESS,
  GET_COUNTRIES,
  GET_COUNTRIES_FAILED,
  GET_COUNTRIES_SUCCESS,
  GET_DEGREES,
  GET_DEGREES_FAILED,
  GET_DEGREES_SUCCESS,
  GET_EDUCATION,
  GET_EDUCATION_FAILED,
  GET_EDUCATION_SUCCESS,
  GET_EDUCATION_TYPES,
  GET_EDUCATION_TYPES_FAILED,
  GET_EDUCATION_TYPES_SUCCESS,
  GET_LABOR_ACIVITY,
  GET_LABOR_ACIVITY_FAILED,
  GET_LABOR_ACIVITY_SUCCESS,
  GET_POSITIONS,
  GET_POSITIONS_FAILED,
  GET_POSITIONS_SUCCESS,
  GET_SCIENTIFIC_INTERESTS,
  GET_SCIENTIFIC_INTERESTS_FAILED,
  GET_SCIENTIFIC_INTERESTS_SUCCESS,
  GET_SETTINGS_MODEL_SUCCESS,
  GET_USER_AUTHORS,
  GET_USER_AUTHORS_FAILED,
  GET_USER_AUTHORS_SUCCESS,
  POST_DEGREES,
  POST_DEGREES_FAILED,
  POST_DEGREES_SUCCESS,
  POST_LABOR_ACIVITY,
  POST_LABOR_ACIVITY_FAILED,
  POST_LABOR_ACIVITY_SUCCESS,
  POST_OBJ_IDENTIFIERS,
  POST_OBJ_IDENTIFIERS_FAILED,
  POST_OBJ_IDENTIFIERS_SUCCESS,
  POST_SCIENTIFIC_INTERESTS,
  POST_SCIENTIFIC_INTERESTS_FAILED,
  POST_SCIENTIFIC_INTERESTS_SUCCESS,
  SEARCH_ORGANIZATION,
  SEARCH_ORGANIZATION_FAILED,
  SEARCH_ORGANIZATION_SUCCESS,
} from '../constants';

import { ClsItem } from 'types/clsType';
import { SettingsModelType } from 'types/settingsType';
import { ProfileStateType } from 'types/stateTypes';
import { ActionType } from '../../types/reduxTypes';

const initialState: ProfileStateType = {
  academicDegrees: [],
  activityAreas: undefined,
  authors: [],
  cities: undefined,
  contacts: [],
  countries: undefined,
  deletedEducation: false,
  deletedLaborActivity: false,
  deletingEducation: false,
  deletingLaborActivity: false,
  education: [],
  educationTypes: undefined,
  laborActivity: [],
  loadingAcademicDegrees: false,
  loadingActivityAreas: false,
  loadingAuthors: false,
  loadingCities: false,
  loadingContacts: false,
  loadingCountries: false,
  loadingEducation: false,
  loadingEducationTypes: false,
  loadingLaborActivity: false,
  loadingPositions: false,
  loadingScientificInterests: false,
  organizations: [],
  positions: undefined,
  savedEducation: false,
  savedLaborActivity: false,
  savingAuthors: false,
  savingContacts: false,
  savingEducation: false,
  savingLaborActivity: false,
  savingScientificInterests: false,
  scientificInterests: [],
  searchingOrg: false,
  settingsModel: undefined,
};

export default (state = initialState, action: ActionType<unknown>): ProfileStateType => {
  switch (action.type) {
    case SEARCH_ORGANIZATION: {
      return { ...state, organizations: [], searchingOrg: true };
    }
    case SEARCH_ORGANIZATION_SUCCESS: {
      return { ...state, organizations: action.payload as Organization[], searchingOrg: false };
    }
    case SEARCH_ORGANIZATION_FAILED: {
      return { ...state, organizations: [], searchingOrg: false };
    }
    case GET_POSITIONS: {
      return { ...state, loadingPositions: true, positions: [] };
    }
    case GET_POSITIONS_SUCCESS: {
      return { ...state, loadingPositions: false, positions: action.payload as ClsItem[] };
    }
    case GET_POSITIONS_FAILED: {
      return { ...state, loadingPositions: false, positions: [] };
    }
    case GET_LABOR_ACIVITY: {
      return { ...state, laborActivity: [], loadingLaborActivity: true };
    }
    case GET_LABOR_ACIVITY_SUCCESS: {
      return { ...state, laborActivity: action.payload as LaborActivity[], loadingLaborActivity: false };
    }
    case GET_LABOR_ACIVITY_FAILED: {
      return { ...state, laborActivity: [], loadingEducation: false };
    }
    case GET_EDUCATION: {
      return { ...state, education: [], loadingEducation: true };
    }
    case GET_EDUCATION_SUCCESS: {
      return { ...state, education: action.payload as Education[], loadingEducation: false };
    }
    case GET_EDUCATION_FAILED: {
      return { ...state, education: [], loadingEducation: false };
    }
    case GET_DEGREES: {
      return { ...state, academicDegrees: [], loadingAcademicDegrees: true };
    }
    case GET_DEGREES_SUCCESS: {
      return { ...state, academicDegrees: action.payload as AcademicDegree[], loadingAcademicDegrees: false };
    }
    case GET_DEGREES_FAILED: {
      return { ...state, academicDegrees: [], loadingAcademicDegrees: false };
    }
    case POST_DEGREES: {
      return { ...state, loadingAcademicDegrees: true };
    }
    case POST_DEGREES_FAILED: {
      return { ...state, loadingAcademicDegrees: false };
    }
    case POST_DEGREES_SUCCESS: {
      return { ...state, loadingAcademicDegrees: false };
    }
    case EDIT_DEGREES: {
      return { ...state, loadingAcademicDegrees: true };
    }
    case EDIT_DEGREES_FAILED: {
      return { ...state, loadingAcademicDegrees: false };
    }
    case EDIT_DEGREES_SUCCESS: {
      return { ...state, loadingAcademicDegrees: false };
    }
    case GET_CONTACTS: {
      return { ...state, contacts: [], loadingContacts: true };
    }
    case GET_CONTACTS_SUCCESS: {
      return { ...state, contacts: action.payload as ContactData[], loadingContacts: false };
    }
    case GET_CONTACTS_FAILED: {
      return { ...state, contacts: [], loadingContacts: false };
    }
    case GET_SCIENTIFIC_INTERESTS: {
      return { ...state, loadingScientificInterests: true, scientificInterests: [] };
    }
    case GET_SCIENTIFIC_INTERESTS_SUCCESS: {
      return {
        ...state,
        loadingScientificInterests: false,
        scientificInterests: action.payload as ScientificInterest[],
      };
    }
    case GET_SCIENTIFIC_INTERESTS_FAILED: {
      return { ...state, loadingScientificInterests: false, scientificInterests: [] };
    }
    case POST_LABOR_ACIVITY: {
      return { ...state, savedLaborActivity: false, savingLaborActivity: true };
    }
    case POST_LABOR_ACIVITY_SUCCESS: {
      return { ...state, savedLaborActivity: true, savingLaborActivity: false };
    }
    case POST_LABOR_ACIVITY_FAILED: {
      return { ...state, savedLaborActivity: false, savingLaborActivity: false };
    }
    case POST_SCIENTIFIC_INTERESTS: {
      return { ...state, savingScientificInterests: true };
    }
    case POST_SCIENTIFIC_INTERESTS_SUCCESS: {
      return { ...state, savingScientificInterests: false };
    }
    case POST_SCIENTIFIC_INTERESTS_FAILED: {
      return { ...state, savingScientificInterests: false };
    }
    case DELETE_LABOR_ACIVITY: {
      return { ...state, deletedLaborActivity: false, deletingLaborActivity: true };
    }
    case DELETE_LABOR_ACIVITY_SUCCESS: {
      return { ...state, deletedLaborActivity: true, deletingLaborActivity: false };
    }
    case DELETE_LABOR_ACIVITY_FAILED: {
      return { ...state, deletedLaborActivity: false, deletingLaborActivity: false };
    }
    case DELETE_EDUCATION: {
      return { ...state, deletedEducation: false, deletingEducation: true };
    }
    case DELETE_EDUCATION_SUCCESS: {
      return { ...state, deletedEducation: true, deletingEducation: false };
    }
    case DELETE_EDUCATION_FAILED: {
      return { ...state, deletedEducation: false, deletingEducation: false };
    }
    case GET_ACTIVITY_AREAS: {
      return { ...state, activityAreas: undefined, loadingActivityAreas: true };
    }
    case GET_ACTIVITY_AREAS_SUCCESS: {
      return { ...state, activityAreas: action.payload as ClsItem[], loadingActivityAreas: false };
    }
    case GET_ACTIVITY_AREAS_FAILED: {
      return { ...state, activityAreas: undefined, loadingActivityAreas: false };
    }
    case GET_EDUCATION_TYPES: {
      return { ...state, educationTypes: undefined, loadingEducationTypes: true };
    }
    case GET_EDUCATION_TYPES_SUCCESS: {
      return { ...state, educationTypes: action.payload as ClsItem[], loadingEducationTypes: false };
    }
    case GET_EDUCATION_TYPES_FAILED: {
      return { ...state, educationTypes: undefined, loadingEducationTypes: false };
    }
    case GET_COUNTRIES: {
      return { ...state, countries: undefined, loadingCountries: true };
    }
    case GET_COUNTRIES_SUCCESS: {
      return {
        ...state,
        countries: (action.payload as ClsItem[]).sort((a, b) => a.term.localeCompare(b.term)),
        loadingCountries: false,
      };
    }
    case GET_COUNTRIES_FAILED: {
      return { ...state, countries: undefined, loadingCountries: false };
    }
    case FIND_CITIES: {
      return { ...state, cities: undefined, loadingCities: true };
    }
    case FIND_CITIES_SUCCESS: {
      return {
        ...state,
        cities: (action.payload as ClsItem[]).sort((a, b) => a.term.localeCompare(b.term)),
        loadingCities: false,
      };
    }
    case FIND_CITIES_FAILED: {
      return { ...state, cities: undefined, loadingCities: false };
    }
    case GET_USER_AUTHORS: {
      return { ...state, authors: [], loadingAuthors: true };
    }
    case GET_USER_AUTHORS_SUCCESS: {
      return { ...state, authors: action.payload as Author[], loadingAuthors: false };
    }
    case GET_USER_AUTHORS_FAILED: {
      return { ...state, authors: [], loadingAuthors: false };
    }
    case POST_OBJ_IDENTIFIERS: {
      return { ...state, savingAuthors: true };
    }
    case POST_OBJ_IDENTIFIERS_SUCCESS: {
      return { ...state, savingAuthors: false };
    }
    case POST_OBJ_IDENTIFIERS_FAILED: {
      return { ...state, savingAuthors: false };
    }
    case GET_SETTINGS_MODEL_SUCCESS: {
      const settingsModel = action.payload as SettingsModelType;
      return { ...state, settingsModel };
    }

    default: {
      return state;
    }
  }
};
